import React from 'react'
import { render } from '@testing-library/react';


const withDoubleClick = (WrappedComponent) => {
    return class NewComponent extends React.Component {

        clicks = [];
        timeout = 0;

        singleClick = (event) => {
            // console.log("single click");
        }

        doubleClick = (event) => {
            // console.log("doubleClick");
        }

        clickHandler = (event) => {
            // console.log("click handler")
            event.preventDefault();
            this.clicks.push(new Date().getTime());
            window.clearTimeout(this.timeout);
            this.timeout = window.setTimeout(() => {
                if (this.clicks.length > 1 && this.clicks[this.clicks.length - 1] - this.clicks[this.clicks.length - 2] < 250) {
                    this.doubleClick(event.target);
                } else {
                    this.singleClick(event.target);
                }
            }, 250);
        }

        constructor(props) {
            super(props);
        }


        render() {
            return (
                <WrappedComponent {...this.props} onClick={this.clickHandler}></WrappedComponent>
            )
        }
    }
}

export default withDoubleClick